import { GET_PORT_OF_LOADINGS } from "../../type/portOfLoading";
// **  Initial State
const initialState = {
  data: [],
  totalRecords: 0,
  totalPages: 1,
  percentage: 0,
  params: {},
};

const portOfLoadingReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PORT_OF_LOADINGS:
      return {
        ...state,
        data: action.payload.results,
        totalPages: action.payload.totalPages,
        totalRecords: action.payload.totalResults,
        params: { limit: action.payload.limit, page: action.payload.page },
      };
    default:
      return state;
  }
};

export default portOfLoadingReducer;
